import { render, staticRenderFns } from "./import-unit.vue?vue&type=template&id=c72e2cf8&"
import script from "./import-unit.vue?vue&type=script&lang=ts&"
export * from "./import-unit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports